import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '../context/authContext';

// Keeps old flat club URLs (e.g. /RedemptionPartner) alive by redirecting them
// into the Option-B nested path /club/:issuerId/<slug>. Used only for pages that
// are exclusively the superadmin's; shared pages (used by roles 101/102) stay on
// their flat routes. If no club is active yet, send to the chooser.
function ClubFlatRedirect({ slug }) {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return null;
  }
  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  // Only an explicitly selected club counts; no issuerId fallback, so a flat URL
  // cannot enter a club that was never chosen from the list.
  const issuerId = user?.selectedClub?.id;
  if (!issuerId) {
    return <Redirect to="/ClubManagement" />;
  }
  return <Redirect to={`/club/${issuerId}/${slug}`} />;
}

export default ClubFlatRedirect;
